import { ICourse, ICourseModule, ICourseModuleLesson } from 'data/entities/course.entity';
import { trackingEvent } from 'data/usecases/tracking-event';
import React, { useEffect, useRef } from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';

interface IVideoPlayerProps extends ReactPlayerProps {
    course: ICourse;
    module: ICourseModule;
    lesson: ICourseModuleLesson;
    transitioning: boolean;
}

const VideoPlayer = ({ course, module, lesson, transitioning, ...props }: IVideoPlayerProps) => {
    const videoRef = useRef<null | ReactPlayer>(null);

    const videoInfos = useRef({ watchedTime: 0, duration: 0 });

    const videoDuration = videoRef.current?.getDuration();
    const videoWatchedTime = videoRef.current?.getCurrentTime();

    useEffect(
        // eslint-disable-next-line arrow-body-style
        () => {
            return () => {
                if (!videoInfos.current.duration || transitioning) return;
                trackingEvent.mixpanel('Video Watched', {
                    productAreaOrigin: 'Aprenda',
                    scenario: 'Video Aula',
                    group: module?.name,
                    step: `${module?.name}/${lesson?.name}`,
                    label: lesson?.name,
                    text: course?.name,
                    specificProperties: {
                        'Tempo assistido': !transitioning
                            ? videoInfos.current.watchedTime
                            : videoInfos.current.duration,
                        'Tempo de video': videoInfos.current.duration,
                        'Assistiu video inteiro':
                            !transitioning && videoInfos.current.duration === videoInfos.current.watchedTime,

                        courseName: course?.name,
                        courseSlug: course?.slug,
                    },
                });

                videoInfos.current = {
                    duration: 0,
                    watchedTime: 0,
                };
            };
        },
        [course?.name, course?.slug, lesson?.name, module?.name, transitioning, videoDuration, videoWatchedTime],
    );

    return (
        <div>
            <ReactPlayer
                ref={videoRef}
                progressInterval={1}
                onProgress={() => {
                    const duration = videoRef.current?.getDuration() as number;
                    const watchedTime = videoRef.current?.getCurrentTime() as number;

                    if (!duration && !watchedTime) return;

                    videoInfos.current = {
                        duration: Math.floor(duration),
                        watchedTime: Math.floor(watchedTime),
                    };
                }}
                {...props}
            />
        </div>
    );
};

export default VideoPlayer;
